import { useMutation } from '@tanstack/react-query'

import { decommissionResource } from '@/features/resource/endpoints/resources'

export function useDecommissionResourceMutation() {
  const { mutateAsync, ...mutationResult } = useMutation({
    mutationFn: (resourceId: string) => decommissionResource(resourceId),
  })

  return {
    decommissionResource: mutateAsync,
    ...mutationResult,
  }
}
